import React from "react";
import _isEmpty from "lodash/isEmpty";
import { useMemo } from "react";

export const AboutContent = ({ data }) => {
  return (
    <div dangerouslySetInnerHTML={{ __html: data?.aboutPage?.Content }}></div>
  );
};
